import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popupconfirm',
  templateUrl: './popupconfirm.component.html',
  styleUrls: ['./popupconfirm.component.scss']
})
export class PopupconfirmComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  public dialogRef: MatDialogRef<PopupconfirmComponent>,) { }

  ngOnInit(): void {
  }

  cancelOrder(){
this.dialogRef.close(false)
  }
  approveOrder(){
    this.dialogRef.close(true)

  }
}
